<div class="shared-access-hint" *ngIf="isGeoLocked">
    <mat-icon>info_outline</mat-icon>
    <span>Freigegebenes Objekt – die Geometrie kann nur im Ursprungskontext geändert werden.</span>
</div>

<div class="my-3" *ngIf="!isGeoLocked">
    <button mat-icon-button aria-label="Undo button" class="m-1" (click)="clickUndo()" [disabled]="!undoActive()"> <mat-icon>undo</mat-icon> </button>
    <button mat-icon-button aria-label="Redo button" class="m-1" (click)="clickRedo()" [disabled]="!redoActive()"> <mat-icon>redo</mat-icon> </button>
</div>

<div id="map" class="map"></div>
<div class="my-3" *ngIf="!isGeoLocked">
    <button mat-raised-button color="primary" (click)="onSave()" >{{'FORM.BTN_SAVE' | translate}}</button>
</div>

<div [hidden]="true">
    <canvas *ngFor="let iconName of defaultSpeciesIcons" [hidden]="true" [id]="iconName" width="48" height="48">Canvas not supported</canvas>
    <canvas *ngFor="let iconName of defaultPoiIcons" [hidden]="true" [id]="iconName" width="48" height="48">Canvas not supported</canvas>
</div>
